/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const TransferWire: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12.25 3.5C14.3211 3.5 16 5.17893 16 7.25C16 9.32107 14.3211 11 12.25 11H6.5C5.11929 11 4 12.1193 4 13.5C4 14.8807 5.11929 16 6.5 16H18.3701L15.8359 13.7471L15.7627 13.6758C15.4197 13.3025 15.4089 12.723 15.7529 12.3359C16.097 11.9489 16.674 11.8915 17.085 12.1885L17.1641 12.2529L21.6641 16.2529C21.8776 16.4427 22 16.7144 22 17C22 17.2856 21.8776 17.5573 21.6641 17.7471L17.1641 21.7471C16.7513 22.114 16.1198 22.0768 15.7529 21.6641C15.386 21.2513 15.4232 20.6198 15.8359 20.2529L18.3701 18H6.5C4.01472 18 2 15.9853 2 13.5C2 11.0147 4.01472 9 6.5 9H12.25C13.2165 9 14 8.2165 14 7.25C14 6.2835 13.2165 5.5 12.25 5.5H9.2998C8.74761 5.49989 8.2998 5.05222 8.2998 4.5C8.2998 3.94778 8.74761 3.50011 9.2998 3.5H12.25Z'
      fill='currentColor'
    />
  </React.Fragment>
)
